<template>
  <div class="federated-search-list-item">
    <div v-if="details" class="federated-search-list-item__details">
      <ahc-federated-search-details
        :details-config="this.detailsConfig"
        :close="this.hideDetails"
        :result="result"
      />
    </div>
    <button
      class="federated-search-list-item__link"
      @click="this.showDetails"
      href="#"
    >
      <div
        :class="`federated-search-list-item__link-contents ${
          grid ? 'federated-search-list-item__link-contents--grid' : ''
        }`"
      >
        <div
          v-if="!this.hideIcon()"
          class="federated-search-list-item__link-contents-image"
          :style="backgroundStyle"
        >
          <!-- Removed alt tag per Level Access to avoid redundant announcements -->
          <img :src="`${this.imageUrl}`" aria-hidden="true" alt="" />
        </div>
        <div class="federated-search-list-item__link-contents-info">
          <span class="federated-search-list-item__link-contents-info-pretitle"
            >{{ this.result["Item Type"] }}
            {{ this.result.Format ? `  |  ${this.result.Format}` : "" }}
          </span>
          <h3
            :class="`federated-search-list-item__link-contents-info-title${
              grid
                ? ''
                : ' federated-search-list-item__link-contents-info-title--line-clamp'
            }`"
          >
            {{ this.result.Title }}
          </h3>
          <span
            :class="`federated-search-list-item__link-contents-info-description${
              grid
                ? ' federated-search-list-item__link-contents-info-description--line-clamp-grid'
                : ' federated-search-list-item__link-contents-info-description--line-clamp'
            }`"
            >{{ this.result.Description }}</span
          >
          <span
            class="federated-search-list-item__link-contents-info-date-and-resource"
            >{{ this.result.Date }}</span
          >
        </div>
      </div>
    </button>
  </div>
</template>

<script lang="js">
  import moment from "moment";
  import ahcFederatedSearchDetails from "./../federated-search-details/federated-search-details.vue";

  const placeholders = {
          "Book": "Book",
          "Periodical": "Periodical",
          "Archival Collection": "Archival_Collection",
          "Archival Collection: File": "Archival_Collection",
          "Archival Collection: Series": "Archival_Collection",
          "Archival Collection: Series Level": "Archival_Collection",
          "Subject File": "Subject_File",
          "Artifact": "Artifact",
          "Digital Resource Image": "Image",
          "Digital Resource Mixed Materials": "Mixed_Materials",
          "Digital Resource Postcard": "Postcard",
          "Digital Resource Publication": "Publication",
          "Digital Resource Audio": "Audio",
          "Digital Resource Video": "Video",
          "Digital Resource Map": "Map",
          "Digital Resource Architecture Drawing": "Drawing",
          "Digital Resource Text": "Text",
          "Digital Resource None / Unknown Format": "Other",
          "Digital Resource Film": "Film",
          "Other": "Other",
        };

  export default  {
    name: 'ahc-federated-search-list-item',
    components: {ahcFederatedSearchDetails},
    computed: {
      imageUrl() {
        if (this.result.video_url) {
          return `https://img.youtube.com/vi/${this.videoId}/hqdefault.jpg`;
        } else if (this.result?.Images?.length) {
          return this.result.Images[0].image_url;
        } else {
          const imageKey = `${this.result['Item Type'] ?? "Other"}${this.result.Format ? ` ${this.result.Format}`: ''}`;
          return `/app/themes/ahc/src/assets/images/federated-search-placeholders/Icon_${this.placeholders[imageKey]}.png`
        }
      },
      backgroundStyle() {
        return `background-image: url(${this.imageUrl})`;
      }
    },
    mounted () {
      if (this.displayDetail) this.showDetails();
      window.addEventListener('resize', () => {this.windowResize(this)});
    },
    methods: {
      // Handles disabling the body and updating the url when showing the details modal
      showDetails(e) {
        if (e) e.preventDefault();
        this.details = true;
        document.body.classList.add("modal-open");
        const url = new URL(window.location.href);
        url.searchParams.set('detail', this.result.objectID);
        window.history.replaceState(null, '', url);
      },
      // Determines if we the placeholder if there is no available image and at mobile size
      hideIcon() {
        return !this.result.video_url && !this.result?.Images?.length && this.isMobile()
      },
      windowResize () { this.innerWidth = window.innerWidth },
      // Handles reenabling the body and updating the url when showing the details modal
      hideDetails() {
        this.details = false;
        document.body.classList.remove("modal-open");
        const url = new URL(window.location.href);
        if (url.searchParams.get('detail') !== null) {
          url.searchParams.delete('detail');
          window.history.replaceState(null, '', url);
        }
      },
      isMobile () {
        return this.innerWidth < 450;
      }
    },
    props: {
      result: {
        type: Object,
        required: true,
      },
      grid: {
        type: Boolean,
        required: false,
        default: false,
      },
      detailsConfig: {
        type: Object,
      },
      displayDetail: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        moment,
        details: false,
        innerWidth: window.innerWidth,
        videoId: this.result.video_url?.split("/").pop(),
        placeholders
      }
    }
}
</script>

<style lang="scss">
@import "federated-search-list-item";
</style>
